import * as React from 'react'
import Svg, { SvgProps, Path } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconCheckmarkLight = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconCheckmarkLight.dimensions.width} ${IconCheckmarkLight.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill={color || Color.premiumBlack}
        fillRule="evenodd"
        d="m7.954 14.681-.002.002a.409.409 0 0 1-.646 0L.884 7.093a.611.611 0 0 1 0-.764.409.409 0 0 1 .646 0l6.1 7.21L17.97 1.316a.409.409 0 0 1 .646 0 .612.612 0 0 1 0 .763L7.954 14.681Z"
        clipRule="evenodd"
      />
    </Svg>
  )
}

IconCheckmarkLight.dimensions = {
  width: 20,
  height: 16,
}

export default IconCheckmarkLight
